// extracted by mini-css-extract-plugin
export default {"container":"Y1sDc99o6hZ80lq7U5oD","box":"_sPJhyHNhJoJ2y1Hcbio","date":"rbXqoAaAbqX5Ec2E5Li0","title":"m1vknYUIslkBgAP0gVjU"};